import { addScript } from "../../bundles/helpers/add-script";
import debounce from 'lodash-es/debounce';
import isBoolean from 'lodash-es/isBoolean';

class CatalogTags {
  constructor(elem) {
    this.block = elem;
    this.block.CatalogTags = this;
    this.swiperWrapper = this.block.querySelector('.catalog-tags__swiper-wrapper');
    this.toggleButton = this.block.querySelector('.catalog-tags__toggle-button');

    this.init();
  }

  init = async () => {
    await this.initSlider();
    this.toggleSlider();

    this.toggleButton?.addEventListener('click', this.toggleList);
    window.addEventListener('resize', this.resize, { passive: true })
    this.block.classList.add('catalog-tags_inited');
  }

  initSlider = async () => {
    if (!window.Swiper) await addScript(PUBLIC_PATH + 'vendor/swiper.vendor.js');
    this.swiper = new Swiper(this.block.querySelector('.catalog-tags__swiper-container'), {
      slidesPerView: 'auto',
      spaceBetween: 10,
    });
  }

  resize = debounce(() => {
    this.toggleSlider();
  })

  toggleSlider = () => {
    if (window.getComputedStyle(this.swiperWrapper).flexWrap !== 'nowrap') {
      if (this.swiper?.destroyed) return;

      this.swiper.slideTo(0);
      this.swiper.destroy();
    } else if (this.swiper?.destroyed) {
      this.initSlider();
    }
  }

  toggleList = (show) => {
    if (isBoolean(show)) this.block.classList.toggle('show', show);
    else this.block.classList.toggle('show');
  }

  destroy = () => {
    window.removeEventListener('resize', this.resize, { passive: true });
    if (this.toggleButton) this.toggleButton.removeEventListener('click', this.toggleList);
    if (this.swiper && !this.swiper.destroyed)   this.swiper.destroy();
    if (this.block) {
      this.block.classList.remove('catalog-tags_inited');
      delete this.block.CatalogTags;
    }
  }

  static init() {
    Array.from(document.querySelectorAll('.catalog-tags:not(.catalog-tags_inited)')).forEach((elem) => new CatalogTags(elem));
  }
}

document.addEventListener('DOMContentLoaded', CatalogTags.init);

// Экспорт;
window.Block = window.Block ? window.Block : {};
window.Block.CatalogTags = CatalogTags;
